/**
 * Query selectors and regular expressions used to match image and video urls.
 *
 * @since 2.1.1
 */

// When used with document.querySelectorAll, this will return all anchors that link to image files.
export const imageLinkQuerySelector = 'a[href*=".jpg"],a[href*=".gif"],a[href*=".png"],a[href*=".svg"]';

// When used with document.querySelectorAll, this will return all anchors that link to video files or urls.
export const videoLinkQuerySelector = '[href*="youtube.com"],[href*="youtu.be"],[href*="vimeo.com"],[href*="wistia.com"],[href*=".mp4"],[href*=".ogg"],[href*=".webm"]';

// Matches urls with video extensions.
export const videoFileRegex = /\.(mp4|ogg|webm)/;

// Matches all YouTube urls: videos, profiles and channels.
export const youtubeRegex =	/(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\/?\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/;

// Matches YouTube profiles and channels.
export const youtubePageRegex =	/youtube\.com\/user|youtube\.com\/channel|youtube\.com\/c\//;

/**
 * Matches all Vimeo urls, capturing the video id and, where one is present,
 * the privacy hash an unlisted video needs on its embed.
 *
 * Capture groups, in the order VideoLightbox reads them:
 *   1. Video id.
 *   2. Privacy hash from the path — vimeo.com/{id}/{hash}, the form Vimeo
 *      hands out for unlisted videos.
 *   3. Privacy hash from the query string — the ?h= on a player.vimeo.com url.
 *
 * `manage/videos/` is in the path alternation because that is the url Vimeo's
 * own admin shows in the address bar, and editors paste it into the resource
 * url field. Without it the lightbox found no src and let the click through to
 * Vimeo instead of opening.
 */
export const vimeoRegex = /(?:https?:)?\/\/(?:www\.|player\.)?vimeo\.com\/(?:manage\/videos\/|channels\/(?:\w+\/)?|groups\/[^/]+\/videos\/|video\/|user\d+\/review\/)?(\d+)(?:\/([a-zA-Z0-9]+))?(?:[?&]h=([a-zA-Z0-9]+))?/;

// Matches all Wistia urls.
export const wistiaRegex = /(?:https?:\/\/(.+)?(wistia\.com|wi\.st)\/(medias|embed)\/)(.*)/;
